<script setup lang="ts"></script>

<template>
  <div class="c-header-main">
    <h1 class="c-header-main__title h2">
      {{ $t('pages.references.header.title') }}
    </h1>

    <div class="c-header-main__divider" />

    <div
      class="c-header-main__description"
      v-html="
        $t('pages.references.header.description', {
          _0: '<strong>',
          _1: '</strong>',
        })
      "
    />
  </div>
</template>

<style lang="scss" scoped>
@use '@inkline/inkline/css/mixins' as *;

.c-header-main {
  color: var(--color-light);

  &__title {
    margin-bottom: 0;
    font-size: 72px;

    @include breakpoint-down('xs') {
      font-size: 36px;
    }
  }

  &__divider {
    margin: 40px 0 0;
    height: 2px;

    @include breakpoint-down('lg') {
      display: none;
    }

    &::before {
      content: '';
      display: block;
      height: 100%;
      margin-left: calc(-50vw + 650px);
      background-color: var(--color-secondary);

      @include breakpoint-down('xl') {
        margin-left: calc(-50vw + 544px);
      }
    }
  }

  &__description {
    font-size: 24px;
    font-weight: 400;
    line-height: 1.32;
    margin-top: 64px;

    @include breakpoint-down('lg') {
      margin-top: 20px;
    }
    @include breakpoint-down('xs') {
      font-size: 18px;
    }

    :deep(strong) {
      font-weight: 400;
      color: var(--color-secondary);
    }
  }
}
</style>
